
export const CITIES = ['Нячанг', 'Хошимин', 'Ханой', 'Дананг', 'Фукуок', 'Вьетнам', 'Россия'];
export const ACTIVITY_SPHERES = [
  'IT & Software',
  'Маркетинг и PR',
  'Недвижимость',
  'Туризм и HoReCa',
  'Инвестиции',
  'Образование',
  'Искусство и Дизайн',
  'Логистика',
  'E-commerce',
  'Криптовалюты',
  'Услуги (Юристы, Бухгалтеры)'
];

export const GOAL_LABELS: Record<string, string> = {
  business: 'Бизнес',
  social: 'Нетворкинг',
  both: 'Бизнес и нетворкинг'
};

export const FORMAT_LABELS: Record<string, string> = {
  online: 'Онлайн',
  offline: 'Лично',
  both: 'Онлайн и лично'
};

export const INITIAL_USERS = [];
export const INITIAL_COMMUNITIES = [];
